import { ListItemButton, List, Radio, ListItemIcon, ListItemText } from '@mui/material';
import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { Business_Profile_Enum } from '@kheops/graphql';
import { availableContextsAtom, currentContextAtom } from '../state';
import { brandsAtom } from '../brands/state';
import { Context } from '../common/models/user.models';
import { getCompanyShortName } from '../common/utils/common.utils';
import CompanyLogo from '../common/components/CompanyLogo';
import { RoutePaths } from '../routes/AppRoutes';
import ContextImage from './ContextImage';

export interface ContextNavigationProps {
  showCurrent?: boolean;
}

export default function ContextNavigation({ showCurrent }: ContextNavigationProps): React.JSX.Element {
  const { companyId: currentCompanyId } = useAtomValue(currentContextAtom);
  const availableContexts = useAtomValue(availableContextsAtom);
  const brands = useAtomValue(brandsAtom);

  const contexts = useMemo((): Context[] => {
    if (showCurrent) {
      return availableContexts;
    }

    return availableContexts.filter((context) => context.companyId !== currentCompanyId);
  }, [availableContexts]);

  const handleMenuItemClick = (companyId: string): void => {
    localStorage.setItem('contextId', companyId);
    window.history.replaceState({ ...window.history.state, newContextId: companyId }, '', `${RoutePaths.ROOT}?contextId=${companyId}`);
    window.location.reload();
  };

  return (
    <List>
      {contexts.map((context) => (
        <ListItemButton key={context.companyId} onClick={() => handleMenuItemClick(context.companyId)}>
          <ListItemIcon>
            {context.realm === Business_Profile_Enum.Buyer && (
              <CompanyLogo
                variant="transparent"
                size="medium"
                sx={{
                  width: 48,
                  height: 48,
                }}
                brand={context.companyBrand}
              />
            )}
            {context.realm === Business_Profile_Enum.Supplier && (
              <ContextImage context={context} size={48} borderRadius={20} />
            )}
          </ListItemIcon>
          <ListItemText
            primary={getCompanyShortName(context.companyName, context.realm)}
            secondary={brands.find((brand) => brand.value === context.companyBrand)?.comment}
          />
          {showCurrent && <Radio checked={currentCompanyId === context.companyId} />}
        </ListItemButton>
      ))}
    </List>
  );
}
